import React from 'react';
import UserAbout from '~co/user/about';

export default function SettingsSidebarUser() {
  return (
    <div className='flex items-center px-[var(--padding-medium)] pt-[var(--padding-small)]'>
      <UserAbout className='flex-1' />
    </div>
  );
}
